module.exports = __webpack_public_path__ + "static/death_knight-e27c410d609f63b903bd495bc044028c.jpeg";